
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $eca075ad100d834d$exports = {};
"use strict";


/*
import urlMetadata from 'url-metadata';

is syntactic sugar for

import { default as urlMetadata } from 'url-metadata';

#################################################
-->> Node modules may not have default exports
*/ function $1af8ab801df7b5fa$var$linkJSScript(shadowRoot, componentPath_URI) {
    const script = document.createElement('script');
    const scriptPath = componentPath_URI.slice(0, componentPath_URI.length - 5) + ".js";
    script.src = scriptPath;
    shadowRoot.appendChild(script);
}
function $1af8ab801df7b5fa$var$linkSCSS(shadowRoot, componentPath_URI) {
    // const stylePath = componentPath_URI.slice(0, (componentPath_URI.length - ".html".length)) + ".css";
    // let styleLink = `<link rel='stylesheet' type='text/css' href='${{stylePath}}'>`;
    const link = document.createElement('link');
    const stylePath = componentPath_URI.slice(0, componentPath_URI.length - 5) + ".Scss";
    link.rel = stylePath;
    shadowRoot.appendChild(link);
}
function $1af8ab801df7b5fa$export$1d94ad8150288a33(shadowRoot, componentPath_URI) {
    try {
        $1af8ab801df7b5fa$var$linkJSScript(shadowRoot, componentPath_URI);
        $1af8ab801df7b5fa$var$linkSCSS(shadowRoot, componentPath_URI);
    } catch (e) {
        console.error(e);
    }
}
function $1af8ab801df7b5fa$export$2a518e19777a8b9(file, path) {
    /**
     * @returns {string} Path of the specified file.
     */ try {
        const files = $eca075ad100d834d$exports.readdirSync(path); //retourne fichiers et dossiers dans ce dossier
        for (const f of files){
            const filePath = path.join(path, f);
            const stat = $eca075ad100d834d$exports.statSync(filePath); /*contient des stats y compris celle qui permet
                            de déterminer si le chemin est celui d'un dossier ou d'un fichier */ 
            if (stat.isDirectory()) {
                //récursion ici
                const found = $1af8ab801df7b5fa$export$2a518e19777a8b9(filePath, f);
                if (found) return found;
            } else if (f === filename) //retourne le chemin du fichier si le fichier est trouvé 
            return filePath;
        }
        return null;
    } catch (e) {
        console.error("Error in findFileByName() : " + e);
        return null;
    }
}


/* ERRORS HANDLING */ /**
 * 
 * @returns {Boolean} Arguments syntax/validity
 */ function $64019b317095e9e5$var$isComponentURIValid(componentURI) {
    try {
        if (typeof componentURI != "string") {
            console.table({
                component_uri: componentURI
            });
            throw "componentURI : not a String";
        }
    } catch (error) {
        console.warn(error);
        return false;
    }
    return true;
}
async function $64019b317095e9e5$export$7c05c44a44181e30(componentURI) {
    try {
        if (!$64019b317095e9e5$var$isComponentURIValid(componentURI)) throw "Invalid arguments. Can't load HTML Component.";
    } catch (loadError) {
        console.warn(loadError);
        return -1;
    }
    let responseComponent = await fetch(componentURI);
    if (!responseComponent.ok) console.error(`HTTP error! status: ${responseComponent.status}`);
    return await responseComponent.text();
}


class $5ed794cee7a27313$export$ece9110dfe5936d2 extends HTMLElement {
    linkHTMLBody(component_html) {
        // Contained in a div to avoid any kind of conflict.
        const htmlContainer = document.createElement('div');
        htmlContainer.innerHTML = component_html;
        this.shadowRoot.appendChild(htmlContainer);
    }
    linkJSScript(component_script) {
        const script = document.createElement('script');
        script.textContent = component_script;
        this.shadowRoot.appendChild(script);
    }
    linkSCSSSheet(component_scss) {
        const style = document.createElement('style');
        style.textContent = component_scss;
        this.shadowRoot.appendChild(style);
    }
    linkAllComponentFiles(component_html, component_script, component_scss) {
        this.linkHTMLBody(component_html); // Linking HTML first to avoid erasing css/js by updating the innerHtml property.
        this.linkSCSSSheet(component_scss);
        this.linkJSScript(component_script);
    }
    linkElement(element) {
        function linkImage(component, imgElem) {
            if (component.hasAttribute("src")) {
                imgElem.src = `${component.getAttribute("src")}`;
                if (!component.hasAttribute("alt")) {
                    console.warn("No alt attribute specified.");
                    return;
                }
                imgElem.alt = component.getAttribute("alt");
            } else console.warn("src attribute not specified. No image loaded.");
        }
        function linkGenericElement(component, elem) {
            if (component.hasAttribute(elem.id)) elem.innerHTML = component.getAttribute(elem.id);
            else console.warn(`${elem.id} attribute not specified in the current document for the ${component.tagNameLowerCase} Component : its content will remain empty.`);
        }
        switch(element.constructor.name){
            case "HTMLImageElement":
                linkImage(this, element);
                break;
            default:
                linkGenericElement(this, element);
        }
    }
    /**
     * Gets attributes from the html tag in the document, and sets their values to
     * the corresponding HTML content/src attribute inside the Component.
     * 
     * **!! Only works once the DOM is loaded and the html document has been fully loaded !!**
     */ linkAllElementsWithId() {
        let elements = this.shadowRoot.querySelectorAll("[id], img");
        if (elements.length < 1) console.info(`${this.tagName} has no element with whose content can be set. Attributes may be useless.`);
        // still running the loop : images do not necessarily have an id but still 
        for(let i = 0; i < elements.length; i++)this.linkElement(elements.item(i));
    }
    getAssetPath(assetName) {
        for(const type in this.assetPaths){
            if (this.assetPaths[type][assetName]) return this.assetPaths[type][assetName];
        }
    }
    disconnectedCallback() {
        console.log('Custom element ' + this.tagNameLowerCase + ' removed from the DOM');
    }
    constructor(){
        super();
        // Getting attributes
        this.tagNameLowerCase = this.tagName.toLowerCase();
        // DOM content loading flags/events
        this.readyState = 'loading';
    }
}



var $071dbf0a121692d6$exports = {};
$071dbf0a121692d6$exports = "";


var $3eb6649b21da5c2a$exports = {};
$3eb6649b21da5c2a$exports = "";


var $4427ce2cee50f71d$exports = {};
$4427ce2cee50f71d$exports = "<div class=text-box id=box1>\n    <p id=text1></p>\n</div>\n<div class=text-box id=box2>\n    <p id=text2></p>\n</div>\n<div class=text-box id=box3>\n    <p id=text3></p>\n</div>\n<div class=text-box id=box4>\n    <p id=text4></p>\n</div>\n\n<img>";


var $a71ae23c578c2b0d$exports = {};
$a71ae23c578c2b0d$exports = "h1{color:green}";


var $ffba7e7e5286dcab$exports = {};
$ffba7e7e5286dcab$exports = "console.warn(\"je suis le code à l'intérieur du component\");";


var $f7b26ba8d4ada0a0$exports = {};
$f7b26ba8d4ada0a0$exports = "<h1>Hugo.AT</h1>\n<p>Bienvenue sur mon site personnel. Que puis-je faire pour vous ?";


class $98928c3f03aea1a0$var$ComponentARemplir extends (0, $5ed794cee7a27313$export$ece9110dfe5936d2) {
    async connectedCallback() {
        this.attachShadow({
            mode: 'open'
        });
        this.linkAllComponentFiles((0, (/*@__PURE__*/$parcel$interopDefault($4427ce2cee50f71d$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($3eb6649b21da5c2a$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($071dbf0a121692d6$exports))));
        // DOM content loading flags/events
        this.dispatchEvent(new CustomEvent('ShadowDOMContentLoaded', {
            detail: {
                class: "ComponentARemplir"
            }
        }));
        this.readyState = 'interactive';
        // Linking declared HTML attributes from the document to the Component's elements innerHTML/src/other type of content.
        this.linkAllElementsWithId();
        ////
        this.readyState = 'complete';
    }
    constructor(){
        super();
    }
}
customElements.define("component-a-remplir", $98928c3f03aea1a0$var$ComponentARemplir);
class $98928c3f03aea1a0$var$PortfolioHeader extends (0, $5ed794cee7a27313$export$ece9110dfe5936d2) {
    async connectedCallback() {
        this.attachShadow({
            mode: 'open'
        });
        this.linkAllComponentFiles((0, (/*@__PURE__*/$parcel$interopDefault($f7b26ba8d4ada0a0$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ffba7e7e5286dcab$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a71ae23c578c2b0d$exports))));
        // DOM content loading flags/events
        this.dispatchEvent(new CustomEvent('ShadowDOMContentLoaded', {
            detail: {
                class: "PortfolioHeader"
            }
        }));
        this.readyState = 'interactive';
        // Linking declared HTML attributes from the document to the Component's elements innerHTML/src/other type of content.
        this.linkAllElementsWithId();
        ////
        this.readyState = 'complete';
    }
    constructor(){
        super();
    }
}
customElements.define("portfolio-header", $98928c3f03aea1a0$var$PortfolioHeader);


//# sourceMappingURL=client.6bb575b3.js.map
